import { useContext } from 'react';
import { MainContext } from '../../contexts/main';
import { isTodayTimestamp, timestampToDayMonth } from '@educaplay/app-core/time';
import { declineReason, renewalText } from '../../helpers/renewal';

export const isRenewalDeclined = (pendingRenewal, paymentMethodId) => (pendingRenewal !== false) && (pendingRenewal.lastDecline !== false) && (pendingRenewal.paymentMethod !== false) && (pendingRenewal.paymentMethod.id == paymentMethodId);

export const BlockRenewalDecline = ({ paymentMethodId, option = false }) => {

    const { mainReducer } = useContext( MainContext );

    const pendingRenewal = mainReducer.state.pendingRenewal;

    if (!isRenewalDeclined(pendingRenewal, paymentMethodId)) {
        return <></>;
    }

    const lastDecline = pendingRenewal.lastDecline;
    const values = { fecha: timestampToDayMonth(lastDecline.date), motivo: declineReason(lastDecline.family) };
    let key = 'renewal_last_decline';
    if (option) {
        key = 'renewal_rejected_on';
    } else if (isTodayTimestamp(lastDecline.date)) {
        key = 'renewal_last_decline_today';
    }

    return <span className="e__plns__opt__pay__rejected">{ renewalText(key, values) }</span>;
}
